import * as React from "react";

import "./error-message.scss";

import {Link,
        makeChain} from "@Common/react/cst2";
import {Types}     from "@Common/types";


export const ErrorMessage = ({
    text
}:{
    text  : string
}) => (

    makeChain<JSX.Element>()

    // return if no message to display
    .then((_, next:Link<JSX.Element, void>) => {
        if (!text) return null;
        return next();
    })

    // render the error message
    .then(() => (
        <div
            className={"error-message-al6 error-message"}
            xd-qa-type="label" xd-qa-name="New Template Error"
        >
            <em>!</em>
            <div>
                <strong>ERROR:</strong> {text}
            </div>
        </div>
    ))

    .run()

);
